import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

import * as globalConst from './../../../../constants';

@Injectable()
export class LogSapService {

  private apiUrl = globalConst.baseAPI;  // URL para web api

  constructor(private http:Http) { }

  getLogs(orderby, sort) {

    return this.http
      .get(this.apiUrl + "order/v1/getlogsap?$orderby=" + orderby + " " + sort, JSON.parse(localStorage.getItem('yara.connectionHeader')))
      .map((res: Response) => res.json()).catch(e => {
      if (e.status === 401) {
        return Observable.throw('Unauthorized');
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/logsap/service/logsap/logsap.service.ts